import {connect} from 'react-redux';

import {navigate} from '/redux/action/navigation.action';

import NavigationProvider from './NavigationProvider';

export default connect(
  null,
  dispatch => ({
    // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
    navigate: ({activeRoutes}: any) => dispatch(navigate({activeRoutes})),
  }),
  (stateProps, dispatchProps, ownProps) => ({
    // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    onRouteChange: ({activeRoutes}: any) => {
      return dispatchProps.navigate({activeRoutes});
    },
  }),
)(NavigationProvider);
